import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { retailers } from '../mock';

export const Trust = ({ hideHeader = false }) => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {!hideHeader && (
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-bold mb-6">
                <CheckCircle2 size={20} />
                PRODUCTO OFICIAL
              </div>
              <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
                La misma gafa que ves en
                <span className="block mt-2 text-blue-900">las grandes tiendas</span>
              </h2>
              <p className="text-xl text-gray-700 leading-relaxed mb-8">
                Las Gafas La Tri que compras aquí son las mismas que encuentras en puntos de venta 
                seleccionados de Supermaxi, Megamaxi, AKÍ, Marathon Sports e islas Panini.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Si ya las has visto en el súper o en Marathon, sabes que es un producto oficial y respaldado. 
                En la web solo lo haces más fácil y directo.
              </p>
            </div>
          )}

          {/* Retailers Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16">
            {retailers.map((retailer, index) => (
              <div 
                key={index}
                data-testid={`retailer-card-${retailer.name.toLowerCase().replace(/\s/g, '-')}`}
                className="bg-white border-2 border-gray-200 rounded-2xl p-6 flex flex-col items-center justify-center gap-3 hover:border-blue-900 hover:shadow-xl transition-all duration-300 group hover:-translate-y-1 min-h-[160px]"
              >
                <div className="flex-1 flex items-center justify-center w-full h-20">
                  <img 
                    src={retailer.logo} 
                    alt={`Logo ${retailer.name}`}
                    className="max-h-16 max-w-full object-contain filter grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-300"
                   loading="lazy" decoding="async" />
                </div>
                <span className="text-gray-700 font-bold text-sm text-center group-hover:text-blue-900 transition-colors">
                  {retailer.name}
                </span>
              </div>
            ))}
          </div>

          {/* Trust Badges */}
          <div className="bg-blue-900 rounded-3xl p-8 lg:p-12 text-white">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-4xl font-black text-yellow-400 mb-2">100%</div>
                <div className="text-lg font-semibold">Producto Oficial</div>
              </div>
              <div>
                <div className="text-4xl font-black text-yellow-400 mb-2">UV400</div>
                <div className="text-lg font-semibold">Protección Certificada</div>
              </div>
              <div>
                <div className="text-4xl font-black text-yellow-400 mb-2">5★</div>
                <div className="text-lg font-semibold">Calificación Clientes</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;
